import { render, staticRenderFns } from "./formticket.vue?vue&type=template&id=440ef81f&"
import script from "./formticket.vue?vue&type=script&lang=js&"
export * from "./formticket.vue?vue&type=script&lang=js&"
import style0 from "./formticket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports